import { createAction, createSlice } from "@reduxjs/toolkit";

const checkEmailSlice = createSlice({
  name: "checkEmail",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
      const { target } = action.payload;
      state.data = { ...state.data, target };
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
      const { isSuccess } = action.payload;
      state.data = { ...state.data, isTargetTaken: isSuccess };
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
      state.data = { ...state.data, isTargetTaken: true };
    },
    reset(state) {
      state.data = null;
      state.processing = false;
    },
  },
});

const { name, actions, reducer } = checkEmailSlice;
const checkEmailAction = createAction(name);
const resetEmailCheckerAction = actions.reset;

export {
  checkEmailAction,
  resetEmailCheckerAction,
  actions as checkEmailActions,
  reducer as checkEmailReducer,
};
